import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Card } from "react-bootstrap";
import { useSection } from "hooks/section";
import parser from "html-react-parser";

import "./AdThumbnail.css";

function AdThumbnail({ slug, title, logoUrl, description, boost, dealDiscount }) {
    const { sectionUrl } = useSection();
    const { search } = useLocation();

    const to = {
        // Some pages, like /search does not have a section
        // use the RedirectWithSection here
        pathname: `${sectionUrl ? `/${sectionUrl}` : ""}/utbildning/${slug}`,
        search: search,
    };

    return (
        <Link to={to} className="AdThumbnail">
            <Card style={{ border: boost ? "2px solid black" : "" }}>
                <Card.Body>
                    <div className="flex-logo">
                        <Card.Img src={logoUrl} alt="logo" loading="lazy" />                        
                    </div>
                   { dealDiscount > 0 && <div className="circle-with-text-grid">
                        Boka nu spara {dealDiscount} kr
                    </div> }
                    <Card.Title>{parser(title)}</Card.Title>
                    <Card.Text>{parser(description)}</Card.Text>
                </Card.Body>
            </Card>
        </Link>
    );
}

export default AdThumbnail;
